
  import { Component, Vue } from "vue-property-decorator";
  import { mapState } from "vuex";
  import { SizeAndPrice } from "../../models/VirtualMachine";
  import SizeAndPriceTable from "@/components/shared/SizeAndPriceTable.vue";
  @Component({
    components: { SizeAndPriceTable },
    computed: {
      ...mapState(["sizeAndPrices"]),
    },
  })
  export default class Documentation extends Vue {
    private activeTab: number = 0;
    public sizeAndPrices!: SizeAndPrice[]; //Is assigned via mapstate
  
    async created() {
      this.$store.dispatch("getSizeAndPrices");
      if (this.$route.query.tab === "templates") {
        this.activeTab = 3;
      } else if (this.$route.query.tab === "manual") {
        this.activeTab = 2;
      }
    }
  }
  